import { render, staticRenderFns } from "./ProgramSekolahDigital.vue?vue&type=template&id=00aab996&"
import script from "./ProgramSekolahDigital.vue?vue&type=script&lang=js&"
export * from "./ProgramSekolahDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports